import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20ecde34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nonbid_index" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tz" }, " 尊敬的客户，请您根据项目实际情况填写保函申请意向单，我司后续将有专属客户经理与您对接！ ", -1))
const _hoisted_3 = { class: "model" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 保函申请 ", -1))
const _hoisted_5 = { class: "types" }
const _hoisted_6 = { class: "types" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "wy" }, "万元", -1))
const _hoisted_8 = { class: "types extra" }
const _hoisted_9 = { class: "model" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 联系人信息 ", -1))
const _hoisted_11 = { style: {"margin":"16px"} }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 立即提交 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_van_form, {
        onFailed: _ctx.onFailed,
        "label-width": "100px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_cell_group, { inset: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                required: "",
                modelValue: _ctx.model.projectname,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.projectname) = $event)),
                clearable: "",
                "input-align": "right",
                "error-message-align": "right",
                label: "项目名称",
                placeholder: "请输入项目名称"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                required: "",
                "input-align": "right",
                "error-message-align": "right",
                label: "产品种类"
              }, {
                input: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.model.bondname = '履约保函')),
                      class: _normalizeClass({'ck':_ctx.model.bondname==='履约保函'})
                    }, "履约保函", 2),
                    _createElementVNode("span", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.model.bondname = '预付款保函')),
                      class: _normalizeClass({'ck':_ctx.model.bondname==='预付款保函'})
                    }, "预付款保函", 2),
                    _createElementVNode("span", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.model.bondname = '质量保函')),
                      class: _normalizeClass({'ck':_ctx.model.bondname==='质量保函'})
                    }, "质量保函", 2),
                    _createElementVNode("span", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.model.bondname = '农民工工资保函')),
                      class: _normalizeClass({'ck':_ctx.model.bondname==='农民工工资保函'})
                    }, "农民工工资保函", 2),
                    _createElementVNode("span", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.model.bondname = '支付保函')),
                      class: _normalizeClass({'ck':_ctx.model.bondname==='支付保函'})
                    }, "支付保函", 2)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_van_field, {
                required: "",
                "input-align": "right",
                "error-message-align": "right",
                label: "保函种类"
              }, {
                input: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.model.lettertype = '银行保函',_ctx.changeORG())),
                      class: _normalizeClass({'ck':_ctx.model.lettertype==='银行保函'})
                    }, "银行保函", 2),
                    _createElementVNode("span", {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.model.lettertype = '担保保函',_ctx.changeORG())),
                      class: _normalizeClass({'ck':_ctx.model.lettertype==='担保保函'})
                    }, "担保保函", 2)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_van_field, {
                required: "",
                label: "出函机构",
                "input-align": "right",
                "error-message-align": "right",
                modelValue: _ctx.model.outorg,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.outorg) = $event)),
                "is-link": "",
                readonly: "",
                placeholder: "请选择出函机构",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showPicker = true))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.model.zbr,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.model.zbr) = $event)),
                "input-align": "right",
                "error-message-align": "right",
                clearable: "",
                required: "",
                label: "受益人名称",
                placeholder: "请输入受益人名称"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.model.danweiname,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.model.danweiname) = $event)),
                "input-align": "right",
                "error-message-align": "right",
                clearable: "",
                required: "",
                label: "被保证人名称",
                placeholder: "请输入被保证人名称"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.model.lettermoney,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.model.lettermoney) = $event)),
                "input-align": "right",
                "error-message-align": "right",
                type: "digit",
                required: "",
                label: "担保金额",
                placeholder: "请输入担保金额"
              }, {
                extra: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                required: "",
                modelValue: _ctx.model.guarantee,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.model.guarantee) = $event)),
                label: "担保期限",
                "input-align": "right",
                type: "digit",
                "error-message-align": "right",
                placeholder: "请输入期限"
              }, {
                extra: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", {
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.guaranteetype = '日')),
                      class: _normalizeClass({'ck':_ctx.guaranteetype==='日'})
                    }, "日", 2),
                    _createElementVNode("span", {
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.guaranteetype = '月')),
                      class: _normalizeClass({'ck':_ctx.guaranteetype==='月'})
                    }, "月", 2),
                    _createElementVNode("span", {
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.guaranteetype = '年')),
                      class: _normalizeClass({'ck':_ctx.guaranteetype==='年'})
                    }, "年", 2)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onFailed"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createVNode(_component_van_form, {
        onFailed: _ctx.onFailed,
        "label-width": "110px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_cell_group, { inset: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                required: "",
                modelValue: _ctx.model.contacts,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.model.contacts) = $event)),
                "input-align": "right",
                clearable: "",
                "error-message-align": "right",
                label: "联系人",
                placeholder: "请输入联系人"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                required: "",
                modelValue: _ctx.model.mobile,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.model.mobile) = $event)),
                "input-align": "right",
                clearable: "",
                "error-message-align": "right",
                type: "digit",
                maxlength: "11",
                label: "联系方式",
                placeholder: "请输入联系方式"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.model.referee,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.model.referee) = $event)),
                "input-align": "right",
                clearable: "",
                "error-message-align": "right",
                label: "推荐人",
                placeholder: "请输入推荐人"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_van_button, {
              block: "",
              loading: _ctx.loading,
              type: "primary",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.goOK())),
              "loading-text": "提交中",
              "native-type": "submit"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        _: 1
      }, 8, ["onFailed"])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.showPicker,
      "onUpdate:show": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.showPicker) = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          columns: _ctx.columns,
          onConfirm: _ctx.onConfirm,
          onCancel: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showPicker = false))
        }, null, 8, ["columns", "onConfirm"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}